export const enumKeys = (en: Object) => {
  return Object.keys(en);
};

export const enumValues = (en: Object) => {
  return Object.values(en);
};
